import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, expand, map, of, switchMap, switchMapTo, tap } from "rxjs";
import { EncryptionService } from "../../dashboard/services/encryption.service";

@Injectable()
export class SuccessInterceptor 
implements HttpInterceptor {
    constructor(
        private _encryptionServie: EncryptionService,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // return next.handle(req).pipe(
        //     tap((event: HttpEvent<any>) => {
        //         let response = event;
        //         if (event?.type === HttpEventType.Response) {
        //             console.log(event)
        //             response = event.clone({body:this._encryptionServie.decryptResponse(event)});
        //         }
        //         console.log(response)

        //         return response

        //     })
        // ) as Observable<HttpEvent<any>>

        return next?.handle(req).pipe(map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              const res = event.body.response? event.clone({body:this._encryptionServie.decryptResponse(event)}):event;
              return res
               
            }
            return this._encryptionServie.decryptResponse(event);
          })) as Observable<HttpEvent<any>>
    }
}